import type { AppLogoProps } from "./app-logo.type";

import { useOrganizationContextInvalid } from "@/modules/organization/organization-context";
import { StaticRouteLink } from "@/modules/static-route";

import "./app-logo.style.less";

const path = "/logo.light.svg";

export const AppLogo = ({ withLink }: AppLogoProps) => {
  const { redirectContext } = useOrganizationContextInvalid();

  return (
    <div className="stelar-logo">
      {withLink ? (
        <StaticRouteLink route="dashboard" customContext={redirectContext}>
          <img src={path} />
        </StaticRouteLink>
      ) : (
        <img src={path} />
      )}
    </div>
  );
};
